import React from "react";
import assets from "../data/config/config_m.json";
import dsPdfs from "../data/pdf.json";
const img = assets.img.desarrolloProfesional;
const img2 = assets.img.general;

var pdfs = dsPdfs[0];

const DesarrolloProfMovil = (props) => {
  return (
    //  <React.Fragment>

    <div>
      <img
        className="titulos img-fluid"
        src={img + "titulo_desarrollo.png"}
        alt="Documentos educativos oficiales"
      />
      <br />

      <div className="row mt-2">
        <div className="col-6 text-right">
          <a
            href="https://capacitacion.mep.go.cr/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              id="cursos"              
              data-infosource={0}
              data-content={pdfs.Tacaco}
              data-typecontent="pdf"
              src="./assets/img/desa-prof/ch_btn_cursosvirtuales.png"
              alt="Cursos virtuales"
            />
          </a>
        </div>
        <div className="col-6">
          <img
            role="button"
            id="recursos"
            data-content={pdfs.Tacaco}
            data-typecontent="pdf"                       
            onClick={props.handlerOpenCatalogWeb}            
            alt="Recursos digitales para educadores"
            src="./assets/img/desa-prof/ch_btn_recursosdigitales.png"
          />
        </div>
      </div>

      <div className="row">
            <div className="col-6 text-right">
              <a
                href="https://www.youtube.com/channel/UCt2Qlh-gT3JsWRJ3el_BclQ"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  id="webinarios"                                  
                  src="./assets/img/desa-prof/ch_btn_webinarios.png"
                  alt="Webinarios"
                />
              </a>
            </div>
            <div className="col-6">
              <img
                role="button"
                src="./assets/img/desa-prof/ch_btn_servicios.png"
                id="servicios"                
                data-tar="Construccion"
                data-origen="DesarrolloProf"               
                onClick={props.changePage}                
                alt="Servicios docentes"
              />
            </div>
          </div>

          <div className="row">
            <div className="col-6 text-right">
              <a
                href="http://videoteca.mep.go.cr/userportal/#/home/main"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  id="videoteca"                  
                  src="./assets/img/desa-prof/ch_btn_videoteca.png"
                  alt="Videoteca"
                />
              </a>
            </div>
            <div className="col-6">
              <img
                role="button"
                src="./assets/img/desa-prof/ch_btn_otrasofertas.png"
                tabIndex="2"
                className="botones-portada img-fluid"
                id="ficha"
                data-content={pdfs.Tacaco}
                data-typecontent="pdf"
                data-infosource={0}                
                onClick={props.handlerOpenCatalog}                
                alt="Otras ofertas de formación"
              />
            </div>
          </div>

          <div className="row">
            <div className="col-6 text-right">
              <a
                href="https://idp.mep.go.cr/vocacion-docente"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="./assets/img/desa-prof/ch_btn_programa_radial.png"
                  id="radial"                                
                  alt="Programa radial Vocación docente"
                />
              </a>
            </div>

            <div className="col-6">
            <a
                href="https://calendario-idp.mep.go.cr/2023/app/index.html"
                target="_blank"
                rel="noopener noreferrer"
              >
              <img
                role="button"
                src="./assets/img/desa-prof/ch_btn_calendario.png"
                id="calendario"
                data-content={pdfs.Tacaco}
                data-typecontent="pdf"
                data-infosource={0}
                // data-tar="Construccion"
                // data-origen="DesarrolloProf"
                // onClick={props.changePage}
                // onKeyPress={props.changePage}
                // onMouseOver={props.onMouseOver}
                // onMouseOut={props.onMouseOut}
                alt="Calendario formación docente"
              />
              </a>
            </div>
          </div>


      <br />

      <audio
        src="https://recursos.mep.go.cr/ws_faro/audios/desarrollo_profesional.mp3"
        id="desarrollo"
        preload="true"
      ></audio>
      <div className="row text-center">
        <div className=" col-12">
          <img
            data-tar="Home"
            onClick={props.changePage}
            className="img-fluid hvr-pop"
            src={img2 + "btn_salir.png"}
            alt="Salir"
          />
        </div>
      </div>
    </div>
  );
};

export default DesarrolloProfMovil;
